import { match } from 'ts-pattern'

import { CurrencyModel } from '../../model'

import FDUSD from './assets/stable/fdusd.svg'
import PYUSD from './assets/stable/pyusd.svg'
import USD1 from './assets/stable/usd1.svg'
import USDC from './assets/stable/usdc.svg'
import USDG from './assets/stable/usdg.svg'
import USDT from './assets/stable/usdt.svg'
import USDY from './assets/stable/usdy.svg'
import USX from './assets/stable/usx.svg'

const eq =
  (...targets: Array<CurrencyModel>) =>
  (currency: CurrencyModel) =>
    targets.some((target) => CurrencyModel.eq(currency, target))

export const getStableCurrencyIconSrc = (
  currency: CurrencyModel,
): string | undefined =>
  match(currency)
    .when(eq(CurrencyModel.UsdcSol), () => USDC)
    .when(
      eq(
        CurrencyModel.UsdtSol,
        CurrencyModel.UsdtEvm,
        CurrencyModel.UsdtTon,
        CurrencyModel.UsdtBase,
        CurrencyModel.UsdtBsc,
      ),
      () => USDT,
    )
    .when(eq(CurrencyModel.PyusdSol), () => PYUSD)
    .when(eq(CurrencyModel.UsdgSol), () => USDG)
    .when(eq(CurrencyModel.Usd1Sol), () => USD1)
    .when(eq(CurrencyModel.UsxSol), () => USX)
    .when(eq(CurrencyModel.FdusdSol), () => FDUSD)
    .when(eq(CurrencyModel.UsdySol), () => USDY)
    .otherwise(() => undefined)
